import { SelfServiceSchedulePaneProps, SelfServiceSchedulePaneType } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';
import { IDataSourceDetailInfo } from '~src/ts/models/IDataSourceInfo';
import { RemoteRefreshAgents } from '~src/ts/resources/RemoteRefreshAgents';
import { IGetRemoteRefreshAgentsResult } from '~src/ts/ServerApi/requests/GetRemoteRefreshAgentsRequest';
import { ChangeDatasourceRemoteRefreshPropertiesHelper, IRemoteRefreshAgentOption } from '~src/ts/services/ChangeDatasourceRemoteRefreshPropertiesHelper';
import { ChangeScheduleActionService } from '~src/ts/services/ChangeScheduleAction';
import { ISelfServiceScheduleDetails } from '../../schedule/types/ISchedule';
import { ICreateExtractTasksScope } from './CreateExtractTaskAction';



export namespace CreateBridgeExtractTaskActionService {

  export function getDefaultSelfServiceSchedulePanePropsForSSSWidget(remoteAgentTimeZone: string): SelfServiceSchedulePaneProps {

    const scheduleDetails: ISelfServiceScheduleDetails = {
      startTime: 300,
      endTime: 0,
      recurrenceMinutes: 1440,
      recurrenceDaysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      recurrenceDayOfMonth: '0',
    };

    const selfServiceSchedulePaneProps = ChangeScheduleActionService.getSelfServiceSchedulePaneProps(
      scheduleDetails, remoteAgentTimeZone != null, remoteAgentTimeZone, 'Weekly',
      SelfServiceSchedulePaneType.BridgeExtractRefresh);

    return selfServiceSchedulePaneProps;
  }

  export function setRemoteAgentOptionsInScope(datasource: IDataSourceDetailInfo, scope: ICreateExtractTasksScope) {
    return RemoteRefreshAgents.get()
      .then((result: IGetRemoteRefreshAgentsResult) => {
        const remoteAgents = ChangeDatasourceRemoteRefreshPropertiesHelper.buildRemoteAgentsList(result, datasource);
        scope.remoteAgentOptions = remoteAgents;
        return scope;
      });
  }

  export function getRemoteAgentOptions(datasource: IDataSourceDetailInfo): Promise<IRemoteRefreshAgentOption[]> {
    return RemoteRefreshAgents.get()
      .then((result: IGetRemoteRefreshAgentsResult) => {
        return ChangeDatasourceRemoteRefreshPropertiesHelper.buildRemoteAgentsList(result, datasource);
      });
  }
}
